export default __webpack_public_path__ + "static/media/2.90019ea8.webp";